export class MarketResearchType {
    readonly name: string;
    readonly category: string;

    constructor(name: string, category: string) {
        this.name = name;
        this.category = category;
    }

    public static PrivateJob = new MarketResearchType(
        "private job",
        "privateJob"
    );
    public static PrivateTool = new MarketResearchType(
        "private tool",
        "privateTool"
    );

    public static PublicJob = new MarketResearchType("public job", "publicJob");
    public static PublicTool = new MarketResearchType(
        "public tool",
        "publicTool"
    );

    public isJob = (): boolean => this.isPrivateJob() || this.isPublicJob();

    public isPrivateJob = (): boolean =>
        MarketResearchType.isPrivateJob(this.name);

    public isPublicJob = (): boolean =>
        MarketResearchType.isPublicJob(this.name);

    public isTool = (): boolean => this.isPrivateTool() || this.isPublicTool();

    public isPrivateTool = (): boolean =>
        MarketResearchType.isPrivateTool(this.name);

    public isPublicTool = (): boolean =>
        MarketResearchType.isPublicTool(this.name);

    public static isPrivateTool = (name: string): boolean =>
        name === "private tool";
    public static isPublicTool = (name: string): boolean =>
        name === "public tool";

    public static isPrivateJob = (name: string): boolean =>
        name === "private job";
    public static isPublicJob = (name: string): boolean =>
        name === "public job";
}
